module Bookhus.Widgets {

    interface IQueue {
        id: number;
        userId: number;
        startdate: Date;
        enddate: Date;
        houses: number[];
        houseCancellationCount: { [key: number]: number };
    }

    interface IAddress {
        streetname: string;
        zipcode: string;
        city: string;
        country: string;
    }

    interface IHouse {
        id: number;
        title: string;
        address: IAddress;
        imageId: number;
        isSelectableByUser: boolean;
    }

    class CancellationTranslations {
        constructor() {

        }

        private translations: any = {
            signup: {
                da: 'Tilmeld afbudsbeskeder',
                'en-GB': 'Sign up for cancellation notices',
                sv: 'Registrera dig för afbudsbeskeder',
                de: 'Melden Sie sich für Kündigungsmitteilungen an',
                no: 'Registrer deg for afbudsbeskeder'
            },
            bothdateshastobefilled: { //error mesage
                da: 'Start og slutdato skal begge være udfyldt',
                'en-GB': 'Start and end dates must both be filled out',
                sv: 'Start- och slutdatum måste fyllas i',
                de: 'Start- und Enddatum müssen beide ausgefüllt werden',
                no: 'Start- og sluttdatoer må begge fylles ut'
            },
            startdatemaynotbeafterenddate: { // error message
                da: 'Start dato må ikke være større end slut dato',
                'en-GB': 'Neither start nor end date must be before today\'s date',
                sv: 'Startdatum får inte vara högre än slutdatum',
                de: 'Das Startdatum darf nicht größer als das Enddatum sein',
                no: 'Startdatoen må ikke være høyere enn sluttdatoen'
            },
            bothdateshastobeaftertoday: { // error message
                da: 'Hverken start eller slut dato må være før dags dato',
                'en-GB': '',
                sv: 'Varken start- eller slutdatum får ligga före dagens datum',
                de: 'Weder Start- noch Enddatum dürfen vor dem heutigen Datum liegen',
                no: 'Verken start- eller sluttdato må være før dagens dato'
            },
            maynotpickaperiodlargerthan365: { // error message
                da: 'Det valgte datospænd må ikke være større en 365 dage',
                'en-GB': 'The selected date range must not exceed 365 days',
                sv: 'Det valda datumintervallet får inte överstiga 365 dagar',
                de: 'Der ausgewählte Zeitraum darf 365 Tage nicht überschreiten',
                no: 'Det valgte datoperioden kan ikke overstige 365 dager'
            },
            enddatemaynotbefurtherthan365: { // error message
                da: 'Slut dato må ikke være længere end 365 dage ud i fremtiden',
                'en-GB': 'End date must not be longer than 365 days in the future',
                sv: 'Slutdatum får inte vara längre än 365 dagar i framtiden',
                de: 'Das Enddatum darf nicht länger als 365 Tage in der Zukunft liegen',
                no: 'Sluttdatoen kan ikke være lenger enn 365 dager i fremtiden'
            },
            edit: { // button text
                da: 'Rediger',
                'en-GB': 'Edit',
                sv: 'Redigera',
                de: 'Bearbeiten',
                no: 'Redigere'
            },
            previous: { // button text
                da: 'Forrige',
                'en-GB': 'Previous',
                sv: 'Tidigare',
                de: 'Bisherige',
                no: 'Tidligere'
            },
            next: { // button text
                da: 'Næste',
                'en-GB': 'Next',
                sv: 'Nästa',
                de: 'Nächster',
                no: 'Neste'
            },
            period: { // button text
                da: 'Periode',
                'en-GB': 'Period',
                sv: 'Period',
                de: 'Zeitraum',
                no: 'Periode'
            },
            arrival: {
                da: 'Ankomst',
                'en-GB': 'Arrival',
                sv: 'Ankomst',
                de: 'Ankunft',
                no: 'Ankomst'
            },
            departure: {
                da: 'Afrejse',
                'en-GB': 'Depature',
                sv: 'Avresa',
                de: 'Abfahrt',
                no: 'Avgang'
            },
            seecancellation: { // button text
                da: 'Se afbud',
                'en-GB': 'See cancellation',
                sv: 'Se avbokning',
                de: 'Siehe Stornierung',
                no: 'Se avbestilling'
            },
            seecancellations: { // button text
                da: 'Se alle afbud',
                'en-GB': 'See cancellations',
                sv: 'Se avbokning',
                de: 'Siehe Stornierung',
                no: 'Se avbestilling'
            },
            cancellations: { // text
                da: 'afbud',
                'en-GB': 'cancellations',
                sv: 'avbokningar',
                de: 'stornierungen',
                no: 'avbestillinger'
            },
            delete: { // button text
                da: 'Slet',
                'en-GB': 'Delete',
                sv: 'Radera',
                de: 'Löschen',
                no: 'Slett'
            },
            cancellationcount: { // widget text
                da: 'Der er {0} afbud',
                'en-GB': 'There\'s {0} cancellations',
                sv: 'Det finns {0} avbokningar',
                de: 'Es gibt {0} Stornierungen',
                no: 'Det er {0} avbestillinger'
            },
            areyousure: { // text
                da: 'Er du sikker?',
                'en-GB': 'Are you sure?',
                sv: 'Är du säker?',
                de: 'Bist du dir sicher?',
                no: 'Er du sikker?'
            },
            startdate: { // text
                da: 'Startdato',
                'en-GB': 'Startdate',
                sv: 'Startdatum',
                de: 'Startdatum',
                no: 'Startdato'
            },
            enddate: { // text
                da: 'Slutdato',
                'en-GB': 'Enddate',
                sv: 'Slutdatum',
                de: 'Endtermin',
                no: 'Sluttdato'
            },
            savechanges: { // button text
                da: 'Gem ændringer',
                'en-GB': 'Save changes',
                sv: 'Spara ändringar',
                de: 'Änderungen speichern',
                no: 'Lagre endringer'
            },
            cancel: { // button text
                da: 'Annuller',
                'en-GB': 'Cancel',
                sv: 'Avbryt',
                de: 'Stornieren',
                no: 'Avbryt'
            },
            create: { // button text
                da: 'Opret ny periode',
                'en-GB': 'Create new period',
                sv: 'Skapa ny period',
                de: 'Neue Periode erstellen',
                no: 'Lag en ny periode'
            },
            noperiodsinqueuelist: {
                da: 'Du har ikke oprettet nogle afbudsnotifikationer',
                'en-GB': 'You have not created any cancellation notifications',
                sv: 'Du har inte skapat några avbokningsmeddelanden',
                de: 'Sie haben keine Kündigungsbenachrichtigungen erstellt',
                no: 'Du har ikke opprettet noen avbestillingsvarsler'
            },
            helpmessage: {
                da: `Du kan her oprette dine afbudsnotifikationer.<br> Du skal vælge perioden og hvilke huse du ønsker notifikationer for.`,
                'en-GB': `You can create your cancellation notifications here.<br> You must select the period and which houses you want notifications for.`,
                sv: `Du kan skapa dina uppsägningsmeddelanden här.<br> Du måste välja period och vilka hus du vill ha aviseringar för.`,
                de: `Hier können Sie Ihre Kündigungsbenachrichtigungen erstellen.<br> Sie müssen den Zeitraum und die Häuser auswählen, für die Sie Benachrichtigungen wünschen.`,
                no: `Du kan opprette avbestillingsvarsler her.<br> Du må velge periode og hvilke hus du ønsker varslinger for.`
            },
            empty: {
                da: '',
                'en-GB': '',
                sv: '',
                de: '',
                no: ''
            }
        }

        private iteration = 0;
        private deadlock = 1;
        get(name: string, lang?: string): string {
            var langCode = $.datepicker.regional.bookhuscurrent as string;
            if (lang != undefined && lang != null) {
                langCode = lang;
            }

            if (this.translations[name] == undefined || this.translations[name] == null) {
                return "Ukendt tekst";
            }

            var value = this.translations[name][langCode];
            if (value == undefined || value == "") {
                if (this.iteration >= this.deadlock) {
                    this.iteration = 0;
                    return "Oversættelse findes ikke";
                }
                this.iteration++;
                return this.get(name, "da");
            }
            this.iteration = 0;
            return value;
        }

    }

    class CancellationQueueService {

        private cache: { [key: string]: Promise<any>; } = {};
        private localization: any;

        constructor() {
            this.localization = (window as any).Bookhus.Localization;
        }

        public loadQueues(forceReload: boolean = false): Promise<IQueue[]> {
            const KEY = "loadQueues";
            if (this.cache[KEY] && !forceReload) {
                return this.cache[KEY]
            }

            this.cache[KEY] = new Promise((resolve, reject) => {
                $.ajax({
                    url: "/api/queuelist/GetQueueListForUser",
                    type: "get",
                    success: (result: any[]) => {
                        result.map(a => this.convertDates(a));
                        resolve(result);
                    },
                    error: function (xhr: JQueryXHR) {
                        reject(xhr.statusText);
                    }
                });
            });
            return this.cache[KEY];
        }

        public loadHouses(forceReload: boolean = false): Promise<IHouse[]> {
            const KEY = "loadHouses";
            if (this.cache[KEY] && !forceReload) {
                return this.cache[KEY]
            }

            this.cache[KEY] = new Promise((resolve, reject) => {
                $.getJSON('/api/queuelist/GetHouses', (result: any[]) => {
                    resolve(result);
                }).fail((xhr: JQueryXHR) => {
                    reject(xhr.statusText);
                });
            });
            return this.cache[KEY];
        }

        public deleteQueue(id: number): Promise<void> {
            return new Promise((resolve, reject) => {
                $.post('/api/queuelist/DeleteQueue?id=' + id, () => {
                    resolve();
                }).fail((xhr: JQueryXHR) => {
                    reject(xhr.statusText);
                });
            });
        }

        public loadQueue(id: number): Promise<any> {
            return new Promise((resolve, reject) => {
                $.getJSON('/api/queuelist/GetQueue?id=' + id, (result: any[]) => {
                    resolve(result);
                }).fail((xhr: JQueryXHR) => {
                    reject(xhr.statusText);
                });
            });
        }

        public saveQueue(queue: IQueue): Promise<void> {
            return new Promise((resolve, reject) => {
                var postData = {
                    id: queue.id,
                    userId: queue.userId,
                    startdate: $.datepicker.formatDate("yy-mm-dd", queue.startdate),
                    enddate: $.datepicker.formatDate("yy-mm-dd", queue.enddate),
                    houses: queue.houses
                };

                $.post('/api/queuelist/SaveQueue', postData, () => {
                    resolve();
                }).fail((xhr: JQueryXHR) => {
                    reject(xhr.responseJSON.message || "Noget gik galt.");
                });
            });
        }

        public convertDates(queue: IQueue): void {
            if (typeof (queue.startdate) == "string") {
                queue.startdate = this.dateFromString(queue.startdate as string);
            }
            if (typeof (queue.enddate) == "string") {
                queue.enddate = this.dateFromString(queue.enddate as string);
            }
        }

        public checkDateSpan(startDate: Date, endDate: Date): Result {
            try {
                var today = new Date().getDateWithoutTime();
                var maxDurationInMiliseconds = 365 * 24 * 60 * 60 * 1000;

                if (startDate == null || endDate == null) {

                    throw this.localization.Standard.UI.ErrorMessage.BothDatesHasToBeFilled;
                }

                if (endDate.getTime() < startDate.getTime()) {
                    throw this.localization.Standard.UI.ErrorMessage.StartDateMayNotBeAfterEndDate;
                }

                if (endDate.getTime() < today.getTime() || startDate.getTime() < today.getTime()) {
                    throw this.localization.Standard.UI.ErrorMessage.BothDatesHasToBeAfterToday;
                }

                if (endDate.getTime() - startDate.getTime() > maxDurationInMiliseconds) {
                    throw this.localization.Standard.UI.ErrorMessage.MayNotPickAPeriodLargerThan365;
                }

                if (endDate.getTime() - today.getTime() > maxDurationInMiliseconds) {
                    throw this.localization.Standard.UI.ErrorMessage.EndDateMayNotBeFurtherThan365;
                }
            }
            catch (error) {
                return new Result(error, true);
            }
            return new Result("Alt ok");
        }

        private dateFromString(str: string): Date {
            var a = $.map(str.split(/[^0-9]/), function (s) { return parseInt(s, 10) });
            return new Date(a[0], a[1] - 1 || 0, a[2] || 1, a[3] || 0, a[4] || 0, a[5] || 0, a[6] || 0);
        }
    }

    class Result {
        public error: boolean;
        public message: string;

        constructor(message = "", error = false) {
            this.error = error;
            this.message = message;
        }
    }


    export class CancellationQueue {

        private container: JQuery;
        private listContainer: JQuery;
        private buttonContainer: JQuery;
        private modalContainer: JQuery;
        private queueService: CancellationQueueService;
        private disallowNonePeriodsForWaitingList: boolean;
        private localization: any;


        constructor(containerSelector: string, disallowNonePeriodsForWaitingList: boolean) {
            this.container = $(containerSelector);
            this.disallowNonePeriodsForWaitingList = disallowNonePeriodsForWaitingList;
            this.queueService = new CancellationQueueService();
            this.localization = (window as any).Bookhus.Localization;
        }

        init(): void {
            this.container.html(`
                ${!this.disallowNonePeriodsForWaitingList ?
                    `<div class="row mb-3">
                        <div class="col text-right">
                            <button type="button" class="btn btn-primary cancellationAdd">${this.localization.Standard.UI.Widgets.CancellationQueue.SignUpForNotification}</button>
                        </div>
                    </div>` : ''}
                <div class="row cancellationList">
                </div>
            `);

            this.container.find('.cancellationAdd').on('click', () => {
                this.openModal({
                    id: 0,
                    userId: 0,
                    startdate: null,
                    enddate: null,
                    houses: [],
                    houseCancellationCount: null
                } as IQueue, this.localization.Standard.UI.ButtonText.Create);
            });

            this.listContainer = this.container.find('.cancellationList');
            this.queueService.loadQueues().then((queues) => {
                this.renderList(queues);
            });

            this.queueService.loadHouses().then((houses) => {
                this.renderModal(houses);
            });

            this.events();
        }

        async renderList(queues: IQueue[]) {
            if (!queues || queues.length == 0) {
                this.displayNoPeriods();
                return;
            }

            var queuesHtml = "";
            var houses = await this.queueService.loadHouses();
            queues.forEach((queue, index) => {

                var editBtn = '<div class="col"></div>';
                if (!this.disallowNonePeriodsForWaitingList) {
                    editBtn = `
                        <div class="col" data-id="${queue.id}">
                            <a href="#" data-command="edit" class="btn btn-secondary btn-block text-nowrap pl-0 pr-0">
                                ${this.localization.Standard.UI.ButtonText.Edit}
                            </a>
                        </div>
                    `;
                }

                queuesHtml += `
                    <div class="col-lg-6 mb-4 queueItem" id="queue_${queue.id}">
                        <div class="card h-100 p-3">
                            <div class="row justify-content-center font-size-1 border-bottom pb-3 mx-0">
                                <span class="text-secondary font-weight-bold mr-3">${this.localization.Standard.UI.GeneralText.Period}:</span>
                                <span class="float-right mr-3"><i class="fa fa-calendar mr-1"></i> ${queue.startdate.toString("d")}</span>
                                <span class="float-right"><i class="fa fa-calendar mr-1"></i> ${queue.enddate.toString("d")}</span>
                            </div>
                            <div class="border-bottom pb-3">
                                ${queue.houses.map((houseId: number) => {
                    var currentHouse = houses.filter(a => a.id == houseId)[0];
                    if (!currentHouse) {
                        return;
                    }

                    return `
                                        <div class="row align-items-center mt-3">
                                            <div class="col-md-3">                                                
                                                <div class="cardImg">
                                                    <img src="/houseimage/${currentHouse.imageId}/150" class="img-fluid rounded" alt="">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <h5 class="mb-1 font-weight-bold">
                                                    ${currentHouse.title}
                                                </h5>
                                                ${currentHouse.address ? `<h6 class="subText mb-1">${currentHouse.address.streetname}, ${currentHouse.address.zipcode} ${currentHouse.address.city}</h6>` : ''}
                                            </div>
                                            <div class="col-md-3" data-id="${queue.id}" data-houseid="${currentHouse.id}">
                                                <a href="#" class="btn btn-link d-flex justify-content-between align-items-center" data-command="show">
                                                    <span class="text-secondary font-weight-bold">${queue.houseCancellationCount && queue.houseCancellationCount.hasOwnProperty(currentHouse.id) ? queue.houseCancellationCount[currentHouse.id] : 0} ${this.localization.Standard.UI.GeneralText.Cancellations}</span>
                                                    <i class="fas fa-eye text-primary"></i>
                                                </a>
                                            </div>
                                        </div>
                                    `;
                }).join('')}                                
                            </div>
                            <div class="row cardBtns mx-0 mt-3">
                                <div class="col pb-3 pb-sm-0" data-id="${queue.id}">
                                    <a href="#" data-command="show" class="btn btn-primary btn-block text-nowrap pl-0 pr-0">
                                        ${this.localization.Standard.UI.ButtonText.SeeCancellations}
                                    </a>
                                </div>
                                ${editBtn}
                                <div class="col" data-id="${queue.id}">
                                    <a href="#" data-command="delete" class="btn btn-danger btn-block text-nowrap pl-0 pr-0">
                                        ${this.localization.Standard.UI.ButtonText.Delete}
                                    </a>
                                </div>
                            </div>                            
                        </div>
                    </div>`;
            });

            if (!queuesHtml || queuesHtml.length == 0) {
                this.displayNoPeriods();
                return;
            }

            this.listContainer.html(queuesHtml);
        }

        renderModal(houses: IHouse[]): void {
            if (!houses || houses.length == 0) {
                return;
            }

            var houseOptions = "";
            houses.forEach((house) => {
                if (!house.isSelectableByUser) {
                    return;
                }

                houseOptions += `<option value="${house.id}">${house.title}</option>`;
            });

            $('body').append(`
                <div class="modal fade" id="editQueueModal" tabindex="-1" role="complementary" aria-label="Rediger afbud venteliste">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-light">
                                <h5 class="modal-title">${this.localization.Standard.UI.ButtonText.Edit}</h5>
                            </div>
                            <div class="modal-body">
                                <p>
                                    ${this.localization.Standard.UI.Widgets.CancellationQueue.HelpMessage}
                                </p>
                                <div class="row">
                                    <div class="form-group col text-center">
                                        <label id="errorMessage" style="color: red; display: none; font-style: italic;"></label>
                                        <input type="hidden" name="id"/>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <label>${this.localization.Standard.UI.GeneralText.StartDate}</label><br/>
                                        <div class="input-group">
                                            <input type="text" name="startdate" class="form-control customDatePicker" autocomplete="off" />
                                            <div class="input-group-append">
                                                <i class="input-group-text icon-ic_calender"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col">
                                        <label>${this.localization.Standard.UI.GeneralText.EndDate}</label><br/>
                                        <div class="input-group">
                                            <input id="enddate" name="enddate" type="text" class="form-control customDatePicker" autocomplete="off" />
                                            <div class="input-group-append">
                                                <i class="input-group-text icon-ic_calender"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col">
                                        <select multiple="true" name="houses" class="form-control" style="max-width: none; height: 150px;">${houseOptions}</select>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button data-command="saveperiod" type="button" class="btn btn-primary">${this.localization.Standard.UI.ButtonText.Save}</button>
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">${this.localization.Standard.UI.ButtonText.Cancel}</button>
                            </div>
                        </div>
                    </div>
                </div>
            `);
            this.modalContainer = $('#editQueueModal');

            this.modalContainer.on('click', '[data-command="saveperiod"]', (e) => {
                var data = {} as IQueue;

                this.modalContainer.find('input, select, textarea').each((index, element) => {
                    var current = $(element);
                    if (current.attr('name') == undefined || current.val() == null) {
                        return;
                    }
                    if (current.prop('type') == "checkbox") {
                        data[current.attr('name')] = current.is(':checked');
                    }
                    else if (current.hasClass('customDatePicker')) {
                        data[current.attr('name')] = current.datepicker('getDate') as Date;
                    }
                    else {
                        data[current.attr('name')] = current.val();
                    }
                });

                var result = this.queueService.checkDateSpan(data.startdate, data.enddate);
                if (result.error) {
                    $('#errorMessage').html(result.message);
                    $('#errorMessage').css('display', 'block');
                    return;
                }

                this.queueService.saveQueue(data as IQueue).then(() => {
                    this.queueService.loadQueues(true).then((queues) => {
                        this.renderList(queues);
                    });
                    this.modalContainer.modal('hide');
                }).catch(function (errorMessage) {
                    $('#errorMessage').html(errorMessage);
                    $('#errorMessage').css('display', 'block');
                });
            });

            $(".customDatePicker").datepicker({
                //buttonImage: "/content/siteimages/calendar31.png",
                //buttonImageOnly: true,
                //buttonText: "Klik for at åbne en kalender",
                /*dateFormat: 'yy-mm-dd',
                dayNames: ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
                dayNamesShort: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
                dayNamesMin: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
                monthNames: ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
                monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],*/
                /*dateFormat: 'dd-mm-yy',*/
                constrainInput: true,
                //showOn: 'button',
                firstDay: 1,
                showWeek: true,
                changeYear: true,
                changeMonth: true,
                /*weekHeader: 'Uge',*/
                yearRange: '2013:+36',
                altFormat: 'yy-mm-dd',
                minDate: 0,
                maxDate: 365,
                beforeShow: function (element: Element, inst: any): any {
                    if ($(element).attr('readonly')) { return false; }
                    setTimeout(function () {
                        $('.ui-datepicker').css('z-index', 99999999999999);
                    }, 0);
                }
            });

            if (this.shouldModalBeDisplayedOnInit()) {
                this.container.find('.cancellationAdd').trigger('click');
            }
        }

        events(): void {
            var self = this;

            self.listContainer.on('click', '[data-command]', function (e) {
                var element = $(e.currentTarget)
                switch (element.attr('data-command')) {
                    case 'delete':
                        swal.fire({
                            title: self.localization.Standard.UI.GeneralText.AreYouSure,
                            icon: 'warning',
                            showCancelButton: true,
                            cancelButtonText: 'Annuller'
                        }).then(function (result) {
                            if (result.isConfirmed) {
                                var id = parseInt(element.parent().attr('data-id'));
                                self.queueService.deleteQueue(id).then(() => {
                                    self.removeElement(id);
                                });
                            }
                        });
                        break;
                    case 'show':
                        var $parent = element.parent();
                        var id = parseInt($parent.attr('data-id'));
                        var houseId = $parent.attr('data-houseid') != undefined ? parseInt($parent.attr('data-houseid')) : 0;

                        self.queueService.loadQueue(id).then((data: IQueue) => {
                            self.queueService.convertDates(data);
                            location.href = `/booking/cancellationlist?arrivalDate=${data.startdate.toString("dd-MM-yyyy HH:mm")}&departureDate=${data.enddate.toString("dd-MM-yyyy HH:mm")}&houseIds=${houseId > 0 ? houseId : data.houses.join(',')}`
                        });
                        break;
                    case 'edit':
                        var id = parseInt(element.parent().attr('data-id'));
                        self.queueService.loadQueue(id).then((data) => {
                            self.queueService.convertDates(data);
                            self.openModal(data as IQueue, self.localization.Standard.UI.ButtonText.Edit)
                        });
                        break;
                }
            });



            self.listContainer.on('click', 'button.page', async (e) => {
                var element = $(e.target);
                var queueId = parseInt(element.attr('data-queueid'));
                var queues = await self.queueService.loadQueues();
                var queue = queues.filter(q => q.id == queueId)[0];
                if (!queue) {
                    return;
                }

                var direction = element.hasClass('next') ? 1 : -1;
                var parent = element.parents('.queueItem:first');
                var newIndex = (parent.prop('hIndex') || 0) + direction;

                if (newIndex < 0) {
                    newIndex = queue.houses.length - 1;
                }
                if (newIndex > queue.houses.length - 1) {
                    newIndex = 0;
                }

                var houseId = queue.houses[newIndex];
                var houses = await this.queueService.loadHouses();
                var house = houses.filter(h => h.id == houseId)[0];

                if (!house) {
                    return;
                }

                parent.find("h5").html(house.title);
                parent.find(".cardImg > img").prop('src', `/houseimage/${house.imageId}/150`);

                parent.prop('hIndex', newIndex);
            });
        }

        getDate(date: string): Date {
            if (date == null) {
                return new Date();
            }

            var match = date.match(/\d+/g)[0];
            if (match.length > 0) {
                return new Date(parseInt(match));
            }
            return new Date();
        }

        removeElement(id: number) {
            $("#queue_" + id).remove();
        }

        openModal(data: IQueue, title: string = "Opret ny afbudsnotifikation") {
            var self = this;

            self.modalContainer.find('.modal-title').html(title);
            self.modalContainer.find('input[name=id]').val(data.id.toString());

            self.modalContainer.find('input[name=startdate]').val(data.startdate == null ? "" : data.startdate.toString("dd-MM-yyyy"));
            self.modalContainer.find('input[name=enddate]').val(data.enddate == null ? "" : data.enddate.toString("dd-MM-yyyy"));
            $('#errorMessage').html('');
            $('#errorMessage').css('display', 'none');


            var houselist = self.modalContainer.find('select[name=houses]')
            houselist.find('option').prop('selected', false);
            for (var i = 0; i < data.houses.length; i++) {
                houselist.find(`option[value=${data.houses[i]}]`).prop('selected', true);
            }

            self.modalContainer.modal('show');
        }

        displayNoPeriods(): void {
            this.listContainer.html(`
                <div class="col-12">
                    <p class="text-center">${this.localization.Standard.UI.Widgets.CancellationQueue.NoPeriodsInQueueList}</p>
                </div>
            `);
        }

        shouldModalBeDisplayedOnInit(): boolean {
            var search = location.search.substring(1);
            var cridentials = search.length > 0 ? JSON.parse('{"' + decodeURIComponent(search).replace(/&/g, '","').replace(/=/g, '":"') + '"}') : {};

            for (var key in cridentials) {
                if (!cridentials.hasOwnProperty(key)) {
                    continue;
                }
                if (key == "opencancellation" && cridentials[key] == "true") {
                    return true;
                }
            }

            return false;
        }
    }
}